__turbopack_context__.v({
  "fallback": "CollateralCover-module-scss-module__k6N-Rq__fallback",
  "play": "CollateralCover-module-scss-module__k6N-Rq__play",
  "video": "CollateralCover-module-scss-module__k6N-Rq__video",
});
